export enum RentPaymentRoleNames {
  PAYER = 'PAYER',
  UNIT_MANAGER = 'UNIT_MANAGER',
}
